// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3kP7l","productName":"Table_productName__316ot"};